import { LoanRequest } from "@bridgesplit/abf-sdk";

export function isRequestFromStrategy(request: LoanRequest | undefined) {
    return !!request?.designatedTaker;
}
